export default __webpack_public_path__ + "static/media/003-tag.21678f43.png";